import { SVGProps, Ref, forwardRef } from 'react';

export const RUSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <rect y={4} width={32} height={24} rx={4} fill="#DADADA" />
            <path d="M0 8a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v4H0z" fill="#EEEEEE" />
            <rect y={12} width={32} height={8} fill="#22408C" />
            <path d="M0 20h32v4a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z" fill="#CE2028" />
        </g>
    </svg>
));
RUSize32Glyph.displayName = 'RUSize32Glyph';
